import { Navigate, Outlet } from 'react-router-dom'
import { FullScreenSpinner } from '@/components/routing/FullScreenSpinner'
import { usePrefetchBulkData } from '@/hooks/products/usePrefetchBulkData'
import { useAuthStore } from '@/store/authStore'

export function PrivateRoute() {
  const { isAuthenticated, isLoading } = useAuthStore()
  usePrefetchBulkData()

  if (isLoading) return <FullScreenSpinner />
  if (!isAuthenticated) return <Navigate to="/login" replace />

  return <Outlet />
}
